<template>
  <div
    id="result"
    class="container h-100"
    :class="{'allowed': canEnter, 'disallowed': !canEnter}"
  >
    <div class="visitor"> 
      <em class="display-3 text-light">Visitor</em>
    </div>
    <h1 class="text-light font-weight-bold display-3">{{ completed }}</h1>
    <h2 class="text-light font-weight-bolder display-4">{{ displayName }}</h2>
    <h3 class="text-light">{{ phone }}</h3>
    <canvas v-show="!canEnter" id="canvas">
    </canvas>
  </div>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'VisitorResult',
  data () {
    return {
      survey: null
    }
  },
  mounted () {
    const id = this.$route.params.id
    const fb = require('../store/firebaseConfig.js')
    var docRef = fb.visitorCollection.doc(id)
    if (docRef) {
      docRef.get()
      .then(ds => {
        // console.log("DOC", ds.data())
        this.survey = ds.data()
      })
    }
  },
  computed: {
    completed () {
      if (this.survey) {
        const dt = new Date(this.survey.waiver)
        return format(dt, "MMM d yyyy")
      }
      return ''
    },
    // surveyId () {
    //   if (this.$store.getters.lastSurvey) {
    //     return this.$store.getters.lastSurvey.id
    //   }
    //   return null
    // },
    lastSurvey () {
      if (this.survey) {
        return this.survey
      }
      return null
    },
    displayName () {
     if (this.survey) {
       return `${this.survey.fname} ${this.survey.lname}`
     }
     return ''
    },
    phone () {
      if (this.survey) {
        return `${this.survey.phone}`
      }
      return ''
    },
    canEnter () {
      if (!this.survey) {
        return false
      }

      const answers = this.survey.questions
      var res = true
      Object.keys(answers).forEach(k => {
        res = res && answers[k] === "No"
      })
      return res
    }
  }
}
</script>

<style scoped>

.allowed {
  background-color: #009900;
}

.disallowed {
  background-color: #990000;
}

.visitor {
  color: white;
}

</style>